import React, { useState } from "react";
import Logo from "../../assets/images/Yogify.png";
import { GiPrayerBeads } from "react-icons/gi";
import { RiSecurePaymentLine } from "react-icons/ri";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LoginBanner from '../../assets/images/login.jpg'

const ForgetPassword = () => {
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    // Email validation function
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        
        // Clear error when user starts typing
        if (emailError) {
            setEmailError("");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validate email
        if (!email.trim()) {
            setEmailError("Email is required");
            return;
        }
        
        if (!validateEmail(email)) {
            setEmailError("Please enter a valid email address");
            return;
        }

        setIsLoading(true);
        setEmailError("");

        try {
            const response = await apiClient.post('/forgot-password', { email });
            
            if (response.status === 200 || response.status === 201) {
                toast.success('OTP sent to your email!');
                const opt = response.data.otp; 
                localStorage.setItem('otp', opt); 
                localStorage.setItem('email', email);
                navigate('/auth/otp', { state: { email } });
            }
        } catch (error) {
            console.error('Error sending OTP:', error);
            
            // Handle different error scenarios
            if (error.response) {
                // Server responded with error status
                const message = error.response.data?.message || 'Failed to send OTP. Please try again.';
                
                if (error.response.status === 404) {
                    setEmailError("Email not found. Please check your email address.");
                } else if (error.response.status === 429) {
                    toast.error("Too many attempts. Please try again later.");
                } else {
                    toast.error(message);
                }
            } else if (error.request) {
                // Network error
                toast.error("Network error. Please check your connection and try again.");
            } else {
                // Other errors
                toast.error("An unexpected error occurred. Please try again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    return (
        <div id="ForgetPassword">
            <div className="container">
                <div className="LoginMain">
                    <div className="LoginBox">
                        <div className="LoginLeftBox">
                            {/* <div className="LoginLogo">
                                <img src={Logo} alt="Yogify Logo" />
                            </div>
                            <div className="LoginTitle">
                                <h2>
                                    Authentic Spiritual Essentials to Help You Connect with Your
                                    True Self
                                </h2>
                            </div>
                            <div className="ProductSecureBox">
                                <div className="SecureBox">
                                    <div className="IconBox">
                                        <GiPrayerBeads className="SecureIcon" />
                                    </div>
                                    <div className="SecureTitle">
                                        <p>Soulful Accessories</p>
                                    </div>
                                    <div className="SecureDescription">
                                        <p>Crafted with Trusted Spiritual Quality</p>
                                    </div>
                                </div>

                                <div className="SecureBox">
                                    <div className="IconBox">
                                        <RiSecurePaymentLine className="SecureIcon" />
                                    </div>
                                    <div className="SecureTitle">
                                        <p>Secure Checkout</p>
                                    </div>
                                    <div className="SecureDescription">
                                        <p>Multiple Payment Options — Fast, Safe & Secure</p>
                                    </div>
                                </div>
                            </div> */}
                             <img src={LoginBanner} alt="" />
                        </div>
                        <div className="LoginRightBox">
                            <div className="Title">
                                <h2>Forgot Password</h2>
                                <p>
                                    Enter your email address and we'll send you an OTP to reset your password.
                                </p>
                            </div>

                            <div className="LoginFormGroup">
                                <form onSubmit={handleSubmit}>
                                    <div className="FormField">
                                        <label>Enter Email Address</label>
                                        <input
                                            type="email"
                                            value={email}
                                            onChange={handleEmailChange}
                                            placeholder="Enter Email Address"
                                            required
                                            disabled={isLoading}
                                            className={emailError ? "error" : ""}
                                        />
                                        {emailError && <span className="error-message">{emailError}</span>}
                                    </div>
                                    <div className="LoginBtn">
                                        <button 
                                            type="submit" 
                                            disabled={isLoading}
                                            className={isLoading ? "loading" : ""}
                                        >
                                            {isLoading ? "Sending OTP..." : "Get OTP"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgetPassword;